import { storage } from 'BASE/common/util/util.storage';
import { actionTypes } from 'BASE/store/types';
export default {
    name: 'Annoucement',
    data: function () {
        return {
            IsOrderByDesc: true,
            Annoucements: [],
            Detail: {},
            EffectiveTime: 5,   //單位分鐘
            EnableTop: false,   //訊息置頂 (當從首頁跑馬燈或其它地方跳轉該公告頁時，對應的訊息是否置頂顯示)
            tag: "",
            apiURL: "GetList",
        };
    },
    computed: {
        isLogin(){
            return this.$store.state.userinfo.isLogin;
        }
    },
    methods: {
        async getList() {
            let _this = this;
            _this.Annoucements = [];

            await _this.GetAnnouncements();

            //網址有夾帶ID取網址的資訊
            if (_this.$route.params.id) {
                let _id = _this.$route.params.id;
                _this.getDetail(_id);
                _this.setTop(_id);
            }
            else if (_this.Annoucements[0]) {
                //如公告有東西，預選第一項目
                _this.getDetail(_this.Annoucements[0].ID);
            }
        },
        getDetail(id) {
            let _this = this;
            this.Detail = {};
            $.each(_this.Annoucements, function (index, value) {
                if (value.ID == id) {
                    _this.Detail = value;
                    _this.Detail.Message = _this.Detail.Message.replace(/\n/g, "<br/>");
                    return false;
                }
            });
        },
        //調整的物件adjustingObject, 參照高度的物件referenceObject (Mobile需將調整物件的高度調整到參照物件的位置)
        detailScrollTop(adjustingObject, referenceObject) {
            $(adjustingObject).scrollTop(0);    //公告詳情區scroll重新置頂，避免切換時是前一個公告的卷軸高度
        },
        setTop(id) {
            let _this = this;
            if (_this.EnableTop)
            {
                $.each(_this.Annoucements, function (index, value) {
                    if (value.ID == id) {
                        value.ID = 0;       //將需要指定的公告ID設成0
                        return false;
                    }
                });

                _this.Annoucements = _this.Annoucements.sort(function (a, b) {
                    if (a.ID < b.ID)
                        return -1;
                    if (a.ID > b.ID)
                        return 1;
                    return 0;
                });
            }
        },
        async GetAnnouncements() {
            let _this = this;

            _this.tag = _this.isLogin ? storage.keys.LOGIN_ANNOUCEMENTS : storage.keys.UNLOGIN_ANNOUCEMENTS;
            let _regAnnoucements = storage.local.get(_this.tag);
            if (_regAnnoucements) {
                _this.Annoucements = _regAnnoucements;
                _this.MergeAnnouncementReadInfo();
            }
            else {
                try {
                    let _result = await $.post(`/api/Annoucement/${_this.apiURL}/${_this.IsOrderByDesc}`);
                    _this.Annoucements = _result;
                    _this.KeepAnnouncementsInStorage();
                }
                catch(err) {
                    console.log(err);
                }
            }
        },
        KeepAnnouncementsInStorage() {
            let _this = this;
            let _newExpiresTime = new Date().getTime() + (_this.EffectiveTime * 60 * 1000);
            storage.local.set(_this.tag, _this.Annoucements, _newExpiresTime);
        },
        async SetAnnouncementRead(announcement) {
            if (!announcement.userRead) {
                announcement.userRead = true;
                await $.post(`/api/Annoucement/SetToRead/` + announcement.ID);
                this.KeepReadAnnouncementInStorage(announcement.ID);
                await this.updateUnreadAnnouncement();
            }
            this.getDetail(announcement.ID);
        },
        async updateUnreadAnnouncement(num) {
            if (num != undefined)
                await this.$store.dispatch(actionTypes.UNREAD_ANNOUNCEMENT, { unreadAnnouncement: num } );
            else
                await this.$store.dispatch(actionTypes.UNREAD_ANNOUNCEMENT);
        },
        KeepReadAnnouncementInStorage(id) {
            let read_list = storage.local.get(storage.keys.READ_ANNOUNCEMENT);
            if ( !read_list )
                read_list = [];
            if (read_list.indexOf(id) < 0 ) {
                read_list.push(id);
                storage.local.set(storage.keys.READ_ANNOUNCEMENT, read_list);
            }
        },
        MergeAnnouncementReadInfo() {
            let _this = this;
            let read_list = storage.local.get(storage.keys.READ_ANNOUNCEMENT);
            if ( read_list ) {
                $.each(_this.Annoucements, function (index, value) {
                    if ( !value.userRead && read_list.indexOf(value.ID) >= 0 ) {
                        value.userRead = true;
                    }
                });
            }
        },
    },
    created: async function () {
        await this.getList();
    }
};